import { linearGradient } from 'polished'
import React from 'react'
import styled from 'styled-components'

import * as AuctionStatus from '../../constants/AuctionStatus'
import { COLOR_PRIMARY } from '../../theme'
import { getAuctionStatusFromTokenMetadata } from '../../utils/auction-status'
import UserLink from '../UserLink'
import NewCardDeadline from './NewCardDeadline'

const Component = styled.div`
  text-align: center;
  color: rgba(255, 255, 255, .5);
`

const Bidding = styled.div`
  text-align: left;
  display: flex;
`

const SoldTo = styled.span`
  span {
    a {
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      white-space: break-spaces;
      font-weight: bold;

      ${linearGradient({
        colorStops: [
          `${COLOR_PRIMARY} 0%`,
          '#17FFD5 100%'
        ],
        toDirection: 'to left'
      })}

      &:hover,
      &:active {
        transform: none !important;
      }
    }
  }
`

const Deadline = styled.div`
  color: white;
`

const Highlight = styled.span`
  color: white;
  font-weight: 600;
`

const ExpiresInfo = styled.div`
`

const BiddingLabel = styled.div`
  font-size: 14px;
  line-height: 1;
  margin-bottom: .25rem;
`

const CurrentBid = styled.div`
  margin-left: auto;
  text-align: right;
`

const NewCardAuctionInfo = ({ tokenMetadata, includeWinner = true }) => {
  const auctionStatus = getAuctionStatusFromTokenMetadata(tokenMetadata)
  const winningBid = tokenMetadata?.winningBid

  if (auctionStatus === AuctionStatus.FRESH) {
    const reservePriceInEth = tokenMetadata.reservePriceInEth

    return (
      <Component>
        Available for
        {' '}
        <Highlight>
          {reservePriceInEth} ETH
        </Highlight>
      </Component>
    )
  } else if (auctionStatus === AuctionStatus.BIDDING_DISABLED) {
    return (
      <Component>
        Bidding is over.
      </Component>
    )
  } else if (auctionStatus === AuctionStatus.SOLD || auctionStatus === AuctionStatus.WAITING_TO_BE_CLAIMED) {
    const winner = winningBid.creator

    return (
      <Component>
        Sold for
        {' '}
        <Highlight>
          {winningBid.amountInEth} ETH
        </Highlight>
        {includeWinner && (
          <>
            {' '}
            to
            {' '}
            <SoldTo>
              <UserLink username={winner.username} />
            </SoldTo>
          </>
        )}
      </Component>
    )
  } else if (auctionStatus === AuctionStatus.BIDDING) {
    return (
      <Component>
        <Bidding>
          <ExpiresInfo>
            <BiddingLabel>
              Expires in
            </BiddingLabel>
            <Highlight>
              <Deadline $colors={tokenMetadata.colors}>
                <NewCardDeadline
                  deadline={tokenMetadata.deadline}
                />
              </Deadline>
            </Highlight>
          </ExpiresInfo>
          <CurrentBid>
            <BiddingLabel>
              Current bid
            </BiddingLabel>
            <Highlight>
              {winningBid?.amountInEth} ETH
            </Highlight>
          </CurrentBid>
        </Bidding>
      </Component>
    )
  }

  return null
}

export default NewCardAuctionInfo
